import { create } from 'zustand';
import type { RoomStore } from './roomStoreTypes';
import {
  createRoomAction,
  deleteRoomAction,
  loadRoomAction,
  loadUserRoomsAction,
  updateRoomAction,
} from './roomStoreRoomActions';
import {
  addMemberAction,
  changeMemberRoleAction,
  clearCurrentRoomAction,
  clearErrorAction,
  getActivityLogAction,
  removeMemberAction,
} from './roomStoreMemberActions';

/**
 * Room state management store.
 */
export const useRoomStore = create<RoomStore>((set, get) => ({
  rooms: [],
  currentRoom: null,
  isLoading: false,
  error: null,

  loadUserRooms: loadUserRoomsAction(set),
  createRoom: createRoomAction(set),
  loadRoom: loadRoomAction(set),
  updateRoom: updateRoomAction(set),
  deleteRoom: deleteRoomAction(set),
  addMember: addMemberAction(set, get),
  removeMember: removeMemberAction(set, get),
  changeMemberRole: changeMemberRoleAction(set, get),
  getActivityLog: getActivityLogAction(set),
  clearCurrentRoom: clearCurrentRoomAction(set),
  clearError: clearErrorAction(set),
}));
